import _defineProperty from "@babel/runtime/helpers/defineProperty";
export class FedopsLoggerWrapper {
  constructor(_ref) {
    let {
      panorama,
      interactionsState
    } = _ref;
    _defineProperty(this, "panorama", void 0);
    _defineProperty(this, "interactionsState", void 0);
    _defineProperty(this, "createInteraction", name => {
      return {
        start: () => this.interactionStarted(name),
        end: () => this.interactionEnded(name)
      };
    });
    this.panorama = panorama;
    this.interactionsState = interactionsState;
  }
  interactionStarted(name) {
    this.interactionsState.start(name);
    this.panorama.transaction(name).start();

    // console.log(`%c ${name}`, 'background: red;');
  }
  async interactionEnded(name) {
    this.panorama.transaction(name).finish();
    await this.interactionsState.fetch();
    if (this.interactionsState.has(name)) {
      this.interactionsState.complete(name);

      // console.log(`%c ${name}`, 'background: green;');
    }
  }
}
//# sourceMappingURL=loggerWrapper.js.map